(function() {
    'use strict';
    angular.module('cabinFlightAdmin', ['ui.router']);
}());